function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.counterUp = t() : e.counterUp = t();
}(self, function () {
  return function () {
    "use strict";

    var e = {
      d: function d(t, n) {
        for (var o in n) {
          e.o(n, o) && !e.o(t, o) && Object.defineProperty(t, o, {
            enumerable: !0,
            get: n[o]
          });
        }
      },
      o: function o(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      },
      r: function r(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }
    },
        t = {};
    e.r(t), e.d(t, {
      default: function _default() {
        return n;
      },
      divideNumbers: function divideNumbers() {
        return r;
      }
    });

    var n = function n(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _t$action = t.action,
          n = _t$action === void 0 ? "start" : _t$action,
          _t$duration = t.duration,
          i = _t$duration === void 0 ? 1e3 : _t$duration,
          _t$delay = t.delay,
          u = _t$delay === void 0 ? 16 : _t$delay;
      if ("stop" === n) return void o(e);
      if (o(e), !/[0-9]/.test(e.innerHTML)) return;
      var l = r(e.innerHTML, {
        duration: i || e.getAttribute("data-duration"),
        delay: u || e.getAttribute("data-delay")
      });
      e._countUpOrigInnerHTML = e.innerHTML, e.innerHTML = l[0] || "&nbsp;", e.style.visibility = "visible";

      var c = function c() {
        e.innerHTML = l.shift() || "&nbsp;", l.length ? (clearTimeout(e.countUpTimeout), e.countUpTimeout = setTimeout(c, u)) : e._countUpOrigInnerHTML = void 0;
      };

      e.countUpTimeout = setTimeout(c, u);
    },
        o = function o(e) {
      clearTimeout(e.countUpTimeout), e._countUpOrigInnerHTML && (e.innerHTML = e._countUpOrigInnerHTML, e._countUpOrigInnerHTML = void 0), e.style.visibility = "";
    },
        r = function r(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _t$duration2 = t.duration,
          n = _t$duration2 === void 0 ? 1e3 : _t$duration2,
          _t$delay2 = t.delay,
          o = _t$delay2 === void 0 ? 16 : _t$delay2,
          r = n / o,
          i = e.toString().split(/(<[^>]+>|[0-9.][,.0-9]*[0-9]*)/),
          u = [];

      for (var _e = 0; _e < r; _e++) {
        u.push("");
      }

      for (var _e2 = 0; _e2 < i.length; _e2++) {
        if (/([0-9.][,.0-9]*[0-9]*)/.test(i[_e2]) && !/<[^>]+>/.test(i[_e2])) {
          (function () {
            var t = i[_e2];

            var n = _toConsumableArray(t.matchAll(/[.,]/g)).map(function (e) {
              return {
                char: e[0],
                i: t.length - e.index - 1
              };
            }).sort(function (e, t) {
              return e.i - t.i;
            });

            t = t.replace(/[.,]/g, "");
            var o = u.length - 1;

            for (var _e3 = r; _e3 >= 1; _e3--) {
              var _i = parseInt(t / r * _e3, 10);

              _i = n.reduce(function (e, _ref) {
                var t = _ref.char,
                    n = _ref.i;
                return e.length <= n ? e : e.slice(0, -n) + t + e.slice(-n);
              }, _i.toString()), u[o--] += _i;
            }
          })();
        } else for (var _t = 0; _t < r; _t++) {
          u[_t] += i[_e2];
        }
      }

      return u[u.length] = e.toString(), u;
    };

    return t;
  }();
});